import script from "./QuestionView.vue?vue&type=script&setup=true&lang=js"
export * from "./QuestionView.vue?vue&type=script&setup=true&lang=js"

import "./QuestionView.vue?vue&type=style&index=0&id=1337e4b7&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1337e4b7"]])

export default __exports__